const labels = {
  All: { 'See the offering': 'Xem cung cấp' },
  FacilityDetails: { 'Ref: Page title': 'Chi tiết cơ sở', 'Ref: Review': 'Kiểm tra lại' },
  FacilitiesList: { 'Ref: Page title': 'Cơ sở ', 'Ref: See details': 'Xem chi tiết' },
};
export default labels;
